import React, { useContext, useState } from "react";

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextArea,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isNull } from "App/utils/helpers";
import {
  FORM_RESET_STATE_WMS_RMT,
  STATUS_PENGERJAAN_DRAFT,
  STATUS_PENGERJAAN_PENGAJUAN,
} from "../../helpers";
import ModalSimpan from "../ModalSimpan/ModalSimpan";
import { getIDunit, getNamaUnit, getUserName } from "App/utils/cookies";
import { RefreshIcon } from "App/Assets";
import { useSelector } from "react-redux";
export default function FormReq(setNewDataReqList) {
  const { setListDetail } = useContext(FormContext);
  const { formData, setFormData } = useContext(FormContext);
  const [showModalSimpan, setShowModalSimpan] = useState(false);
  const handleReset = () => {
    setFormData(FORM_RESET_STATE_WMS_RMT);
    setListDetail([]);
    // setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
  };

  const master = useSelector(({ master }) => master);
  const fullAkses = master.access_fa.access;

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  const gudang = useSelectOption(
    true,
    "/wmsMasterAsset/gudang/list",
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "body",
    fullAkses ? {} : isNull(getIDunit())
      ? {}
      : {
          params: {
            unit: getIDunit(),
          },
        }
  );

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleResetUser = () => {
    setFormData({
      ...formData,
      user_request: getUserName(),
      unit_id: getIDunit(),
      unit: isNull(getNamaUnit()) ? 'Pilih Unit' : getNamaUnit(),
    });
  };

  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          setShowModal={() => setShowModalSimpan(false)}
          resetForm={() => handleReset()}
          setNewDataReqList={setNewDataReqList}
        />
      )}

      <form action="">
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <Grid container spacing={1}>
              <Grid item sm={4}>
                <InputTextMaster
                  name="id"
                  label="ID"
                  id="id"
                  placeholder="ID Help Desk"
                  disabled={true}
                  value={formData.id}
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="user"
                  label="USERNAME REQUEST"
                  id="user"
                  disabled={
                    true
                    // formData.status_request >= STATUS_TRANSAKSI_PENGAJUAN
                    //   ? true
                    //   : false
                  }
                  value={formData?.user_request}
                  placeholder="UserName Request"
                  onChange={handleChange("user_request")}
                  withButton={
                    formData.status_request === STATUS_PENGERJAAN_DRAFT
                      ? true
                      : false
                  }
                >
                  {formData.status_request === STATUS_PENGERJAAN_DRAFT ? (
                    <button
                      type={"button"}
                      onClick={(e) => handleResetUser()}
                      style={{
                        borderRight: "1px solid #EAEAEA",
                        borderTop: "1px solid #EAEAEA",
                        borderBottom: "1px solid #EAEAEA",
                        borderLeft: "0",
                        background: "#fff",
                        padding: "0 0.8rem",
                        cursor: "pointer",
                        borderRadius: "0 6px 6px 0",
                      }}
                    >
                      <RefreshIcon width={"16"} height={"16"} fill={"#333"} />
                    </button>
                  ) : (
                    <></>
                  )}
                </InputTextMaster>
              </Grid>
              <Grid item sm={4}>
                <InputOptionMaster
                  name="id_unit"
                  label="UNIT"
                  id="id_unit"
                  disabled={
                    !isNull(getIDunit()) ? true : 
                    formData.status_request === STATUS_PENGERJAAN_DRAFT ?
                    false :
                    true
                  }
                  withSearch={true}
                  value={isNull(getIDunit()) ? formData.unit_id : getIDunit()}
                  labelValue={
                    isNull(getIDunit()) ? formData.unit : getNamaUnit()
                  }
                  onChange={(e) => {
                    if (isNull(getIDunit())) {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          id_unit: null,
                          unit: "Pilih Unit",
                        });
                      } else {
                        setFormData({
                          ...formData,
                          unit_id: e.value,
                          unit: e.label,
                        });
                      }
                    } else {
                    }
                  }}
                  data={unit}
                  error={true}
                />
              </Grid>
              <Grid item sm={6}>
                <InputOptionMaster
                  name="gudang_id"
                  label="GUDANG FIXED ASSET"
                  id="gudang_id"
                  withSearch={true}
                  data={gudang}
                  disabled={
                    formData.status_request === STATUS_PENGERJAAN_DRAFT
                      ? false
                      : true
                  }
                  value={formData.gudang_id}
                  labelValue={formData.gudang}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        gudang_id: null,
                        gudang: "Pilih Gudang",
                      });
                    } else {
                      setFormData({
                        ...formData,
                        gudang_id: e?.value,
                        gudang: e?.label,
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item sm={6}>
                <div
                  style={{
                    marginTop: "0.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label htmlFor="date" className="form-control-label">
                    TANGGAL
                  </label>

                  <div
                    onClick={() =>
                      setFormData({
                        ...formData,
                        date: moment(new Date()).local().toDate(),
                      })
                    }
                    style={{
                      fontSize: "10px",
                      color: "#3399ff",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </div>
                </div>
                <DatePicker
                  id="date"
                  autoComplete="off"
                  className="form-control text"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  locale="id-ID"
                  selected={moment(formData.taggal_request).toDate()}
                  disabled={
                    formData.status_request === STATUS_PENGERJAAN_DRAFT
                      ? false
                      : true
                  }
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      taggal_request: e,
                    });
                  }}
                  placeholderText="Tanggal"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item sm={3}>
            <InputTextArea
              name="remark"
              disabled={
                formData.status_request === STATUS_PENGERJAAN_DRAFT
                  ? false
                  : true
              }
              label="CATATAN"
              id="remark"
              placeholder="Catatan"
              rows={6}
              value={formData.remark}
              onChange={handleChange("remark")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextArea
              name="remark"
              disabled={true}
              label="CATATAN VERIFIKASI"
              id="remark"
              placeholder="Catatan"
              rows={6}
              value={formData.remark_recive}
            />
          </Grid>
          <Grid item sm={12}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <MasterButton
                className={"mt-1"}
                type="button"
                color={"danger"}
                outline={true}
                name={"RESET"}
                onClick={() => handleReset()}
                size="md"
              />

              <div>
                <MasterButton
                  type={"button"}
                  color="green"
                  name="Simpan"
                  size="lg"
                  onClick={() => setShowModalSimpan(!showModalSimpan)}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
